import React from 'react'
import { Route } from 'react-router-dom'

import NoMatchRoute from '.'

const router = <Route component={NoMatchRoute} />

export default router
